import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";

import { MonitorViewVehicleRoutes } from "./monitorViewVehicleRoutes";
import { Tab, Tabs, Typography } from "@mui/material";
import { t } from "i18next";
import { MonitorViewVehicleCurrentStatus } from "./monitorViewVehicleCurrentStatus";
import { useAppDispatch } from "../../../framework/customStore";
import { setIsVehicleRouteView } from "../../../store/monitorViewSlice";

const tabs = {
    now: "now",
    route: "route"
}

export const MonitorViewVehicle = ({
}) => {
    const dispatch = useAppDispatch();
    const [selectedTab, setSelectedTab] = useState<string>(tabs.now);

    const onChangeTab = (newValue: string) => {
        dispatch(setIsVehicleRouteView(newValue === tabs.route));
        setSelectedTab(newValue);
    };

    useEffect(() => {
        dispatch(setIsVehicleRouteView(selectedTab === tabs.route));
    }, []
    );

    return (
        <>
            <>
                <Box sx={{ bgcolor: "#f5f5f5" }}>
                    <Tabs
                        value={selectedTab}
                        onChange={(event, newValue) => onChangeTab(newValue as string)}
                        variant="fullWidth"
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab
                            key={tabs.now}
                            value={tabs.now}
                            label={
                                <Box sx={{ textAlign: "center" }}>
                                    <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>{t("monitorView.now")}</Typography>
                                </Box>
                            }
                            sx={{ minWidth: 0, padding: "6px" }}
                        />
                        <Tab
                            key={tabs.route}
                            value={tabs.route}
                            label={
                                <Box sx={{ textAlign: "center" }}>
                                    <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>{t("monitorView.route")}</Typography>
                                </Box>
                            }
                            sx={{ minWidth: 0, padding: "6px" }}
                        />
                    </Tabs>
                </Box>
                {selectedTab === tabs.now ?
                    <MonitorViewVehicleCurrentStatus /> :
                    <MonitorViewVehicleRoutes />
                }
            </>
        </>
    );
};
